import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const PublicRoute = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white">
        <img src="/assets/loading.gif" alt="Chargement..." className="w-24 h-24" />
        <p className="mt-6 text-lg text-paragaia font-semibold">Chargement...</p>
      </div>
    );
  }


  if (!user) return children;

  if (
    location.pathname === '/signin' ||
    location.pathname === '/signup'
  ) {
    if (user.role === 'admin' && user.dashboardUrl) {
      return <Navigate to={`/admin/${user.dashboardUrl}`} replace />;
    }
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PublicRoute;
